import { render } from "./SelfieInstruction3.vue?vue&type=template&id=9d06a374"
import script from "./SelfieInstruction3.vue?vue&type=script&lang=js"
export * from "./SelfieInstruction3.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__